import { render, staticRenderFns } from "./Dishes.vue?vue&type=template&id=96f460bc"
import script from "./Dishes.vue?vue&type=script&lang=js"
export * from "./Dishes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports